import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommodityXref extends Layout {
    buttonCommodityExpand: Button;
    horizontalspacerForCommodity: HorizontalSpacer;
    labelCommodity: Label;
    panelCommodity: Panel;
    panelCommodityButtons: Panel;
    panelCommodityCollapsible: Panel;
    panelHeader: Panel;
    sourceEdiCommodity: DataSource;
    tableCommodity: Table;
}
